<template>
  <iframe style="width: 100%; min-height: 600px" v-if="data" v-bind:src="data" />
</template>

<script>
export default {
  props: ["data"],
};
</script>